/**
 * Borrowing ToolBob's client means borrowing its hash-style redirect URI
 * (`/#/signin-callback`). The auth server turns that into
 * `/?/signin-callback?code=...` (or leaves it as `/#/signin-callback?code=...`),
 * which neither the history router nor oidc-client can parse. Rewrite it to
 * `/signin-callback?code=...` before the router starts (ToolBob's Electron main
 * process does the same rewrite).
 * TODO: drop this once we have our own OneID client with a plain redirect.
 */
export function normalizeHashCallbackUrl(loc: Location = globalThis.location): void {
  const target = toPlainCallbackUrl(loc.search, loc.hash);
  if (target) globalThis.history.replaceState(null, "", target);
}

/** Returns the plain `/signin-callback?...` URL, or null if this isn't a hash-style callback. */
export function toPlainCallbackUrl(search: string, hash: string): string | null {
  for (const [value, prefix] of [
    [search, "?/signin-callback"],
    [hash, "#/signin-callback"],
  ] as const) {
    if (value.startsWith(prefix)) {
      const query = value.slice(prefix.length).replace(/^[?&]/, "");
      return `/signin-callback?${query}`;
    }
  }
  return null;
}
